// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { superpathjoin } from 'superpathjoin';

import type { TranslatorProps } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { ListCell, ListItem } from '@gandi/ui/deprecated';

import { selectAdminURL } from '../../../modules/config';
import type { FullState } from '../../../types';

type OwnProps = {
  translator: TranslatorProps,
};

type StateProps = {
  href: string,
};

type Props = {
  ...StateProps,
  ...OwnProps,
};

function NoRenewablesRow({ href, translator: { __ } }: Props) {
  return (
    <ListItem backgroundColor="white">
      <ListCell
        icon={{ name: 'checkmark', fill: 'success', position: 'prefix' }}
      >
        <Base
          tagName="span"
          dangerouslySetInnerHTML={__(
            'No products to renew within the next 2 months.' +
              ' <a href=%(href)s>See dashboard</a>',
            {
              withHTML: true,
              href,
            },
          )}
        />
      </ListCell>
    </ListItem>
  );
}

const mapStateToProps = (state: FullState): StateProps => ({
  href: superpathjoin(selectAdminURL(state), 'dashboard/search'),
});

const Memo: React.ComponentType<OwnProps> = React.memo<OwnProps>(
  // $FlowFixMe[underconstrained-implicit-instantiation]
  connect(mapStateToProps)(NoRenewablesRow),
);
Memo.displayName = 'NoRenewablesRow';

export default Memo;
